const swiperContainers = document.querySelectorAll(".video-cards-swiper");

swiperContainers.forEach((container) => {
 new Swiper(container, {
  slidesPerView: 1.5,
  spaceBetween: 20,
  loop: false,
  breakpoints: {
   768: {
    slidesPerView: 3,
    spaceBetween: 20,
   },
   1280: {
    slidesPerView: 3,
    spaceBetween: 32,
   },
  },
  grabCursor: true,
  keyboard: {
   enabled: true,
   onlyInViewport: true,
  },
 });
});
